import type React from "react";

import {
  Drawer as DesignSystemDrawer,
  type DrawerBaseProps,
  type DrawerRootProps as DesignSystemDrawerRootProps,
} from "@/design-system/Drawer";
import { useTranslation } from "@/translations";

export type { DrawerBaseProps };

export type DrawerRootProps = Omit<DesignSystemDrawerRootProps, "closeLabel">;

function DrawerRoot(props: DrawerRootProps): React.ReactNode {
  const { t } = useTranslation();

  return <DesignSystemDrawer.Root {...props} closeLabel={t("common.action.close")} />;
}

export const Drawer = {
  Root: DrawerRoot,
  Body: DesignSystemDrawer.Body,
  Actions: DesignSystemDrawer.Actions,
  Close: DesignSystemDrawer.Close,
};
